import {
  SAVE_DESTINATION_LIST, SAVE_DESTINATION, SAVE_SERVICE_SITE, INVALIDATE_DESTINATION_LIST, INVALIDATE_DESTINATION,
} from '../actions/destination';

const defaultState = {
  destinationList: undefined,
  destinationMap: {},
  serviceSiteMap: {},
};

const convertDestination = (destinationData, isComplete) => {
  const {
    changeOrders, // not null
    customer, // not null
    serviceSites, // not null
    ...destination
  } = destinationData;

  return {
    ...destination,
    changeOrders: changeOrders || undefined,
    customer: customer || undefined,
    serviceSites: serviceSites || undefined,

    isPartial: !isComplete,
  };
};

const convertServiceSite = (serviceSiteData, isComplete) => {
  const {
    destination, // omit
    tasks, // not null
    ...serviceSite
  } = serviceSiteData;

  return {
    ...serviceSite,
    tasks: tasks || undefined,

    isPartial: !isComplete,
  };
};

const saveDestinationList = (state, destinationList) => {
  if (!destinationList) {
    return state;
  }

  const { destinationMap: destinationMapState, serviceSiteMap: serviceSiteMapState } = state;

  const destinationMap = {
    ...destinationMapState,
  };

  const serviceSiteMap = {
    ...serviceSiteMapState,
  };

  destinationList.data.forEach((destination) => {
    const { id, serviceSites = [] } = destination;
    const { isPartial = true } = destinationMap[id] || {};

    if (id === undefined) {
      return;
    }

    if (isPartial) {
      destinationMap[id] = convertDestination(destination, false);
    }

    serviceSites.forEach((serviceSite) => {
      const { id } = serviceSite;
      const { isPartial = true } = serviceSiteMap[id] || {};

      if (id === undefined) {
        return;
      }

      if (isPartial) {
        serviceSiteMap[id] = convertServiceSite(serviceSite, false);
      }
    });
  });

  return {
    ...state,
    destinationList,
    destinationMap,
    serviceSiteMap,
  };
};

const invalidateDestinationList = (state) => {
  const { destinationList } = defaultState;

  return {
    ...state,
    destinationList,
  };
};

const invalidateDestination = (state, destinationId) => {
  const { destinationMap: { [destinationId]: remove, ...rest } } = state;
  return {
    ...state,
    destinationMap: {
      ...rest,
    },
  };
};

const saveDestination = (state, destination) => {
  const { id, serviceSites = [] } = destination || {};

  if (id === undefined) {
    return state;
  }

  const { destinationMap: destinationMapState, serviceSiteMap: serviceSiteMapState } = state;

  const destinationMap = {
    ...destinationMapState,
    [id]: {
      ...destination,
      isPartial: false,
    },
  };

  const serviceSiteMap = {
    ...serviceSiteMapState,
  };

  serviceSites.forEach((serviceSite) => {
    const { id } = serviceSite;
    const { isPartial = true } = serviceSiteMap[id] || {};

    if (id === undefined) {
      return;
    }

    if (isPartial) {
      serviceSiteMap[id] = convertServiceSite(serviceSite, false);
    }
  });

  return {
    ...state,
    destinationMap,
    serviceSiteMap,
  };
};

const saveServiceSite = (state, serviceSite) => {
  const { id, destination, destination: { id: destinationId } = {} } = serviceSite || {};

  if (id === undefined) {
    return state;
  }

  const { serviceSiteMap, destinationMap: destinationMapState } = state;

  const destinationMap = {
    ...destinationMapState,
  };

  if (destinationId !== undefined) {
    const { [destinationId]: { isPartial: destinationIsPartial } = {} } = destinationMap;

    if (destinationIsPartial === undefined) {
      destinationMap[destinationId] = convertDestination(destination, false);
    }
  }

  return {
    ...state,
    destinationMap,
    serviceSiteMap: {
      ...serviceSiteMap,
      [id]: convertServiceSite(serviceSite, true),
    },
  };
};

export default (state = defaultState, action) => {
  const { type } = action;

  switch (type) {
    case SAVE_DESTINATION_LIST: {
      const { destinationList } = action;
      return saveDestinationList(state, destinationList);
    }
    case INVALIDATE_DESTINATION_LIST: {
      return invalidateDestinationList(state);
    }
    case INVALIDATE_DESTINATION: {
      const { destinationId } = action;
      return invalidateDestination(state, destinationId);
    }
    case SAVE_DESTINATION: {
      const { destination } = action;
      return saveDestination(state, destination);
    }
    case SAVE_SERVICE_SITE: {
      const { serviceSite } = action;
      return saveServiceSite(state, serviceSite);
    }
    default: {
      return state;
    }
  }
};
